import Header from "./components/Header";
import Footer from "./components/Footer";
import Login from "./components/Login";
import LandingAfterLogin from "./components/LandingAfterLogin";
import Agreement from "./components/Agreement";
import ConfirmAgree from "./components/confirmAgree";
import PurchaseSuccess from "./components/PurchaseSuccess";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import RefundPolicy from "./components/RefundPolicy";
import Pricing from "./components/Pricing";
import PaidUser from "./components/PaidUser";
import { Routes, Route, Router } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import "./assets/styles/App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from "react-redux";

function App() {
  const { isAuthenticated } = useSelector((state) => state.root);

  return (
    <div className="App">
      <Header className="Header"></Header>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/pricing" element={<Pricing />} />

        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route path="/trial-user" element={<LandingAfterLogin />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/update-profile" element={<ConfirmAgree />} />
          <Route path="/PurchaseSuccess" element={<PurchaseSuccess />} />
          <Route path="/subscribed-user" element={<PaidUser />} />
        </Route>
      </Routes>
      <Footer className="Footer"></Footer>
    </div>
  );
}

export default App;
